import {createReducer, on} from '@ngrx/store';
import {BelegState} from '../../interfaces/beleg-state.interface';
import {BelegActions} from '../actions/beleg.actions';

export const initialBelegState: BelegState = {
  belegPreviewData: {
    belegIsLoading: false,
    closeable: true,
    highlightText: '',
    isPdfViewerDialogOpen: false,
  },
  belegFilterDialogData: {
    isBelegFilterDialogOpen: false,
    count: 0,
    filter: {},
    pagination: {
      offset: 0,
      size: 50,
    },
  },
  belegCancelledDialogData: {
    isBelegCancelledDialogOpen: false,
    showAsOverlay: false,
  },
};

export const belegReducers = createReducer(
  initialBelegState,

  /*
   * INFO: Beleg Preview Reducers
   */

  on(BelegActions.loadContent, (state, action) => ({
    ...state,
    belegPreviewData: {
      ...state.belegPreviewData,
      tryToLoadBeleg: action.belegDto,
      belegIsLoading: true,
      previewBelegDto: undefined,
      content: undefined,
      closeable: action.closeable,
    },
  })),

  on(BelegActions.contentLoaded, (state, action) => ({
    ...state,
    belegPreviewData: {
      ...state.belegPreviewData,
      previewBelegDto: action.belegDto,
      content: action.content,
      belegIsLoading: false,
      tryToLoadBeleg: undefined,

      /*
       * TODO:
       * Sobald via OpenAPI verfügbar, zusätzlich über folgendes Flag prüfen
       * (contentType === 'application/xml'
       *   && beleg?.getBelegbucherkennungsart() == Belegbucherkennungsart.XRechnung)
       */
      isPdf: action.belegDto?.contentType === 'application/pdf' || action.belegDto?.contentType === 'application/xml',
    },
  })),

  on(BelegActions.loadIframeContent, state => ({
    ...state,
    belegPreviewData: {
      ...state.belegPreviewData,
      iFramePreviewDialogBeleg: undefined,
      iFramePreviewDialogContent: undefined,
    },
  })),

  on(BelegActions.iFrameContentLoaded, (state, action) => ({
    ...state,
    belegPreviewData: {
      ...state.belegPreviewData,
      iFramePreviewDialogBeleg: action.belegDto,
      iFramePreviewDialogContent: action.content,
    },
  })),

  on(BelegActions.openPdfViewerDialog, state => ({
    ...state,
    belegPreviewData: {
      ...state.belegPreviewData,
      isPdfViewerDialogOpen: true,
    },
  })),

  on(BelegActions.closePdfViewerDialog, state => ({
    ...state,
    belegPreviewData: {
      ...state.belegPreviewData,
      isPdfViewerDialogOpen: false,
    },
  })),

  on(BelegActions.closeBelegPreview, state => ({
    ...state,
    belegPreviewData: {
      ...initialBelegState.belegPreviewData,
    },
  })),

  on(BelegActions.resetBelegPreview, state => ({
    ...state,
    belegPreviewData: {
      ...state.belegPreviewData,
      isPdf: undefined,
      tryToLoadBeleg: undefined,
      content: undefined,
      previewBelegDto: undefined,
      belegIsLoading: false,
      closeable: undefined,
    },
  })),

  on(BelegActions.highlightText, (state, action) => ({
    ...state,
    belegPreviewData: {
      ...state.belegPreviewData,
      highlightText: action.highlightText,
    },
  })),

  /*
   * INFO: Beleg-Filter-Dialog Reducers
   */

  on(BelegActions.openBelegFilterDialog, state => ({
    ...state,
    belegFilterDialogData: {
      ...state.belegFilterDialogData,
      isBelegFilterDialogOpen: true,
      filter: initialBelegState.belegFilterDialogData.filter,
      pagination: initialBelegState.belegFilterDialogData.pagination,
    },
  })),

  on(BelegActions.closeBelegFilterDialog, state => ({
    ...state,
    belegFilterDialogData: {
      ...state.belegFilterDialogData,
      isBelegFilterDialogOpen: false,
      lastPreviewed: undefined,
      filter: initialBelegState.belegFilterDialogData.filter,
      pagination: initialBelegState.belegFilterDialogData.pagination,
    },
  })),

  on(BelegActions.loadData, (state, action) => ({
    ...state,
    belegFilterDialogData: {
      ...state.belegFilterDialogData,
      data: action.data,
      count: action.count,
    },
  })),

  on(BelegActions.setFilter, (state, action) => ({
    ...state,
    belegFilterDialogData: {
      ...state.belegFilterDialogData,
      filter: action.filter,
    },
  })),

  on(BelegActions.changePagination, (state, action) => ({
    ...state,
    belegFilterDialogData: {
      ...state.belegFilterDialogData,
      pagination: action.pagination,
    },
  })),

  on(BelegActions.resetPagination, state => ({
    ...state,
    belegFilterDialogData: {
      ...state.belegFilterDialogData,
      pagination: initialBelegState.belegFilterDialogData.pagination,
    },
  })),

  on(BelegActions.belegToAssignSelected, (state, action) => ({
    ...state,
    belegFilterDialogData: {
      ...state.belegFilterDialogData,
      belegToAssignSelected: action.belegDto,
    },
  })),

  /*
   * INFO: Beleg Storniert Reducers
   */

  on(BelegActions.openBelegCancelledDialog, (state, action) => ({
    ...state,
    belegCancelledDialogData: {
      isBelegCancelledDialogOpen: true,
      showAsOverlay: true,
      inhaberId: action.inhaberId,
      zahlungId: action.zahlungId,
    },
  })),

  on(BelegActions.closeBelegCancelledDialog, state => ({
    ...state,
    belegCancelledDialogData: {
      isBelegCancelledDialogOpen: false,
      showAsOverlay: false,
      inhaberId: undefined,
      zahlungId: undefined,
    },
  })),
);
